// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa","4923": "82388680","5111": "69f5c5ab","5282": "275b299e","8153": "ecd0595f",}[chunkId] + ".css"
}